<template>
  <div :style="{width: `${width}`}">
    <el-input v-model.trim="search.keyword" class="keyword-input" :placeholder="placeholder" clearable @change="onSearch">
      <i v-if="showSearchIcon" slot="suffix" class="el-icon-search" />
    </el-input>
  </div>
</template>

<script>
export default {
  name: 'GjwSearch',
  props: {
    placeholder: {
      type: String,
      default: '请输入关键词'
    },
    width: {
      type: String,
      default: '100%'
    },
    showSearchIcon: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      search: {
        keyword: ''
      }
    }
  },
  methods: {
    reset() {
      this.search = {
        keyword: ''
      }
      this.$emit('change')
    },
    onSearch() {
      this.$emit('change', this.search.keyword)
    },

  }
}
</script>

<style lang="less" scoped>

</style>
